import { render, staticRenderFns } from "./HumanizedDate.vue?vue&type=template&id=95a22bb2&"
import script from "./HumanizedDate.vue?vue&type=script&lang=ts&"
export * from "./HumanizedDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports